import * as Utils from "../utils/Config";
import { AuthContextModel } from '../App'
import { ApiClient } from "./ApiClient";
import { IOrthodonticReferral, IOrthodonticReferralOralHygiene, IOrthodonticReferralSagittal, IOrthodonticReferralToothDeviation, IOrthodonticReferralTransversalBite, IOrthodonticReferralVerticallBite, IOrthodonticReferralTreatmentNeeds } from "../models/IOrthodonticReferral";
import { ICareProvider } from "../models/ICareProvider";

export class OrthodonticReferralApi extends ApiClient {

    constructor(auth: AuthContextModel) {
        super(auth);
    }

    getOrthodonticReferral(orthodonticReferralId: number, refresh: boolean, success: (data: IOrthodonticReferral) => void, error?: (message: string) => void, final?: () => void) {
        this.get<IOrthodonticReferral>(`${Utils.LIB_API_BASE_URL}/orthodonticReferral/${orthodonticReferralId}?refresh=${refresh}`, success, error, final);
    }

    getOrthodonticReferralReferrer(success: (data: ICareProvider) => void, error?: (message: string) => void, final?: () => void) {
        this.get<ICareProvider>(`${Utils.LIB_API_BASE_URL}/orthodonticReferral/referrer`, success, error, final);
    }

    getOrthodonticReferralRecipient(patientId: number, success: (data: ICareProvider) => void, error?: (message: string) => void, final?: () => void) {
        this.get<ICareProvider>(`${Utils.LIB_API_BASE_URL}/orthodonticReferral/recipient/${patientId}`, success, error, final);
    }

    getOrthodonticReferralOralHygienes(success: (data: IOrthodonticReferralOralHygiene[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get<IOrthodonticReferralOralHygiene[]>(`${Utils.LIB_API_BASE_URL}/orthodonticReferral/orthodonticReferralOralHygienes`, success, error, final);
    }

    getOrthodonticReferralTreatmentNeeds(success: (data: IOrthodonticReferralTreatmentNeeds[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get<IOrthodonticReferralTreatmentNeeds[]>(`${Utils.LIB_API_BASE_URL}/orthodonticReferral/orthodonticReferralTreatmentNeeds`, success, error, final);
    }

    getOrthodonticReferralSagittals(success: (data: IOrthodonticReferralSagittal[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get<IOrthodonticReferralSagittal[]>(`${Utils.LIB_API_BASE_URL}/orthodonticReferral/orthodonticReferralSagittals`, success, error, final);
    }

    getToothDeviations(success: (data: IOrthodonticReferralToothDeviation[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get<IOrthodonticReferralToothDeviation[]>(`${Utils.LIB_API_BASE_URL}/orthodonticReferral/toothDeviations`, success, error, final);
    }

    getTransversalBites(success: (data: IOrthodonticReferralTransversalBite[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get<IOrthodonticReferralTransversalBite[]>(`${Utils.LIB_API_BASE_URL}/orthodonticReferral/transversalBites`, success, error, final);
    }

    getVerticallBites(success: (data: IOrthodonticReferralVerticallBite[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get<IOrthodonticReferralVerticallBite[]>(`${Utils.LIB_API_BASE_URL}/orthodonticReferral/verticallBites`, success, error, final);
    }

    downloadOrthodonticReferralAttachment(orthodonticReferralAttachmentId: number, fileName?: string, error?: (message: string) => void) {
        this.getFile(`${Utils.LIB_API_BASE_URL}/orthodonticReferral/file/${orthodonticReferralAttachmentId}`, fileName ?? "", undefined, error);
    }
}